import { useMemo } from 'react';
import { navigationItems, type NavigationItem } from '@/lib/navigation';
import { usePermissions } from './usePermissions';

/**
 * Returns navigation items filtered by the current user's permissions.
 * Items are hidden (not shown at all) if the user doesn't have the required permission.
 */
export function useFilteredNavigation(): NavigationItem[] {
  const { hasPermission, hasAnyPermission, isSuperAdmin } = usePermissions();

  return useMemo(() => {
    return navigationItems.filter((item) => {
      // Check super admin only constraint
      if (item.superAdminOnly && !isSuperAdmin) {
        return false;
      }

      // Check single required permission
      if (item.requiredPermission && !hasPermission(item.requiredPermission)) {
        return false;
      }

      // Check any-of permissions
      if (item.requiredAnyPermission && !hasAnyPermission(item.requiredAnyPermission)) {
        return false;
      }

      return true;
    });
  }, [hasPermission, hasAnyPermission, isSuperAdmin]);
}
